module.exports = __webpack_public_path__ + "img/lock.3bf78669.svg";